// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model-modal {
    font-weight: bold;
}

#productDescriptionGenericBlock,
#productDescriptionOptionsBlock {
    padding-bottom: 30px;
    border-bottom: 0.5px solid #DEDEDE;
    position: relative;
    margin-right: 33%;
}

#productDescriptionGenericTitle {
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
}

#productDescriptionBack {

    position: absolute;
    top: 15px;
    font-weight: bold;
    color: #3C3C3B;
    text-transform: uppercase;
    font-size: 10px;
}
#productDescriptionBack svg {
    margin-right: 9px;
}


#productDescriptionOptionsBlock {
    margin-top: 25px;
}

#productDescriptionTechnicBlock{
    margin-top: 25px;
    margin-bottom: 25px;
}
#productDescriptionTechnicTitle,
#productDescriptionOptionsTitle{
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    display: block;
    text-transform: uppercase;
    color: #3C3C3B;
}


#productDescriptionBack {
    text-transform: uppercase;
    font-size: 10px;
}

#productDescriptionGenericTitle {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    display: block;
    text-transform: uppercase;
    color: #3C3C3B;
}

#productDescriptionGenericKey {
    color: #C5C5C5;
    font-size: 12px;
    line-height: 17px;
    display: block;
}

#productDescriptionGenericValue {
    font-size: 17px;
    color: #3C3C3B;
    line-height: 23px;
    display: block;
    margin-bottom: 15px;
    font-weight: 500;
}

#productDescriptionTechnicKey {
    color: #C5C5C5;
    font-size: 12px;
    line-height: 17px;
    display: block;
}

#productDescriptionTechnicValue {
    font-size: 17px;
    color: #3C3C3B;
    line-height: 23px;
    display: block;
    margin-bottom: 15px;
    font-weight: 500;
}

.productDescriptionGenericBlockImage {
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    right: -130%;
    width: 87vw;
    height: 100%;
}

.nbModel {
    font-size: 20px;
}

.modelDetails:hover svg {
    color: rgb(255, 158, 23);
}

.productUserTransit, .productUserTransit:hover {
    color: #1E90FF;
}
.productUserOwned, .productUserOwned:hover {
    color: #00FF00;
}

#clear-search {
    color: #495057;
    border-color: #ced4da;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.productsNb {
    font-weight: bold;
    text-decoration: underline;
}

.backLinkModel {
    letter-spacing: 1px;
    margin-left: 10px;
    z-index: 9999;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/App/css/Model.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,oBAAoB;IACpB,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;;IAEI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,cAAc;AAClB;;;AAGA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;AACnB","sourcesContent":[".model-modal {\n    font-weight: bold;\n}\n\n#productDescriptionGenericBlock,\n#productDescriptionOptionsBlock {\n    padding-bottom: 30px;\n    border-bottom: 0.5px solid #DEDEDE;\n    position: relative;\n    margin-right: 33%;\n}\n\n#productDescriptionGenericTitle {\n    font-size: 16px;\n    font-weight: bold;\n    text-transform: uppercase;\n}\n\n#productDescriptionBack {\n\n    position: absolute;\n    top: 15px;\n    font-weight: bold;\n    color: #3C3C3B;\n    text-transform: uppercase;\n    font-size: 10px;\n}\n#productDescriptionBack svg {\n    margin-right: 9px;\n}\n\n\n#productDescriptionOptionsBlock {\n    margin-top: 25px;\n}\n\n#productDescriptionTechnicBlock{\n    margin-top: 25px;\n    margin-bottom: 25px;\n}\n#productDescriptionTechnicTitle,\n#productDescriptionOptionsTitle{\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 15px;\n    display: block;\n    text-transform: uppercase;\n    color: #3C3C3B;\n}\n\n\n#productDescriptionBack {\n    text-transform: uppercase;\n    font-size: 10px;\n}\n\n#productDescriptionGenericTitle {\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 15px;\n    display: block;\n    text-transform: uppercase;\n    color: #3C3C3B;\n}\n\n#productDescriptionGenericKey {\n    color: #C5C5C5;\n    font-size: 12px;\n    line-height: 17px;\n    display: block;\n}\n\n#productDescriptionGenericValue {\n    font-size: 17px;\n    color: #3C3C3B;\n    line-height: 23px;\n    display: block;\n    margin-bottom: 15px;\n    font-weight: 500;\n}\n\n#productDescriptionTechnicKey {\n    color: #C5C5C5;\n    font-size: 12px;\n    line-height: 17px;\n    display: block;\n}\n\n#productDescriptionTechnicValue {\n    font-size: 17px;\n    color: #3C3C3B;\n    line-height: 23px;\n    display: block;\n    margin-bottom: 15px;\n    font-weight: 500;\n}\n\n.productDescriptionGenericBlockImage {\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    position: absolute;\n    top: 0;\n    right: -130%;\n    width: 87vw;\n    height: 100%;\n}\n\n.nbModel {\n    font-size: 20px;\n}\n\n.modelDetails:hover svg {\n    color: rgb(255, 158, 23);\n}\n\n.productUserTransit, .productUserTransit:hover {\n    color: #1E90FF;\n}\n.productUserOwned, .productUserOwned:hover {\n    color: #00FF00;\n}\n\n#clear-search {\n    color: #495057;\n    border-color: #ced4da;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.productsNb {\n    font-weight: bold;\n    text-decoration: underline;\n}\n\n.backLinkModel {\n    letter-spacing: 1px;\n    margin-left: 10px;\n    z-index: 9999;\n    font-weight: bold;\n    text-transform: uppercase;\n    font-size: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
